<div class="wrapper" [ngClass]="{ 'has-borders': hasBorders }">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align review-section">
    <div class="section-header text-uppercase">
      {{ title }}
      <sup>
        <i
          class="pi pi-info-circle hint-icon"
          *ngIf="showTooltip && !!tooltip && !tooltip.startsWith('tooltips.')"
          [tooltipStyleClass]="tooltipStyleClass"
          [pTooltip]="tooltip"
          [tooltipPosition]="tooltipPosition"></i>
      </sup>
    </div>

    <div class="section-btns" *ngIf="areButtonsVisible">
      <i
        *ngIf="isDetailsView && showAcceptRejectButtons"
        class="pi pi-check"
        [ngClass]="[areButtonsDisabled ? 'lock-icon-style' : '', areButtonsDisabled ? 'default-cursor' : '']"
        [pTooltip]="showLockTooltip ? ('review-section.review-ok-tooltip' | translate) : null"
        [tooltipPosition]="showLockTooltip ? 'bottom' : null"
        (click)="createSectionReview(sectionStatus.approved)"
        [style]="{ color: review?.status === sectionStatus.approved ? 'green' : null }"
        tabindex="0"
        appEnterClick></i>

      <i
        *ngIf="isDetailsView && showAcceptRejectButtons"
        class="pi pi-times"
        [ngClass]="[areButtonsDisabled ? 'lock-icon-style' : '', areButtonsDisabled ? 'default-cursor' : '']"
        [pTooltip]="showUnlockTooltip ? ('review-section.review-not-ok-tooltip' | translate) : null"
        [tooltipPosition]="showUnlockTooltip ? 'bottom' : null"
        (click)="createSectionReview(sectionStatus.rejected)"
        [style]="{ color: review?.status === sectionStatus.rejected ? 'red' : null }"
        tabindex="0"
        appEnterClick></i>

      <i
        *ngIf="
          showMessages &&
          isDetailsView &&
          ((showComments && review?.status === sectionStatus.rejected) || sectionMessages?.length || !this.showAcceptRejectButtons)
        "
        class="pi pi-comment comment-icon"
        [pTooltip]="'comment-section.comment-tooltip' | translate"
        tooltipPosition="bottom"
        (click)="op.toggle($event)"
        tabindex="0"
        appEnterClick>
        <span *ngIf="sectionMessages?.length" class="msg-counter">{{ sectionMessages.length }}</span>
      </i>

      <app-button-delete *ngIf="deletable && (!isDetailsView || isDataEditable)" (click)="onDelete()"></app-button-delete>
    </div>
  </div>

  <p-overlayPanel #op [appendTo]="'body'" [style]="{ width: '30%', height: '400px' }">
    <app-review-message-container
      *ngIf="op.overlayVisible"
      [applicationId]="_applicationId"
      [sectionId]="sectionId"
      [entityId]="entityId"
      [sectionMessages]="sectionMessages"
      [allowCreateMessage]="canCreateMessages"></app-review-message-container>
  </p-overlayPanel>

  <div class="review-section-content">
    <ng-content></ng-content>
  </div>
</div>
